
export const secret = 'Zycxan04';